import { Form } from 'react-bootstrap';

const Currency = ({
  label,
  name,
  value,
  onChange,
  className,
  labelClassName,
  inputClassName,
  placeholder,
}) => {
  const handleChange = (e) => {
    if (e.target.value.split('').filter((x) => (x !== ',' && x !== 0 && Number.isNaN(Number(x)))).length) {
      return;
    }

    e.target.value = e.target.value.replaceAll(',', '');

    if (Number(e.target.value) < 0) {
      e.target.value = 0;
    }

    if (Number(e.target.value) > 2147483647) {
      e.target.value = 2147483647;
    }

    Number(e.target.value);
    onChange(e);
  };

  const numberWithCommas = (x) => (x ?? '').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return (
    <div className={className}>
      {label && <Form.Label className={labelClassName}>{label}</Form.Label>}
      <div className="d-flex align-items-center w-100">
        <Form.Control
          name={name}
          value={numberWithCommas(value)}
          id="inputCurrency"
          className={inputClassName}
          onChange={handleChange}
          placeholder={placeholder}
        />
      </div>
    </div>
  );
};

export default Currency;
